import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import moment from 'moment'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { setFavorite, unsetFavorite } from '../../../../redux/actions/favorites'
import { getClientNovelties } from '../../../../redux/actions/novelties'
import { IRootState } from '../../../../redux/types'
import FeedHeader from '../../styles/FeedHeader'
import ShareIcon from '../icons/ShareIcon'
import CardHero from './CardHero'

function NewsFeed() {
  const { t } = useTranslation(['global'])
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { news } = useSelector((state: IRootState) => state.novelty)
  const { globalCountryId, globalLanguageId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    dispatch(
      getClientNovelties({
        country_id: globalCountryId,
        language_id: globalLanguageId,
        type: 'news',
        requesttype: 2
      })
    )
  }, [globalCountryId, globalLanguageId])

  const cutContent = (content: string) => {
    let trimmedString: string = ''
    trimmedString = content.substring(0, Math.min(content.length, content.indexOf('</p>')))
    return trimmedString
  }

  const handleFavoriteClick = (id: number, type: string, inputField: string) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id,
          state,
          type,
          favoritefield: inputField
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id,
          state,
          type: type,
          favoritefield: inputField
        })
      )
    }
  }

  return (
    <>
      {news.length > 0 && (
        <FeedHeader xs={12}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5">{t('featured')}</Typography>
            <Typography
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                navigate(`/noticias`)
              }}
              color="textSecondary"
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
                '&:hover': {
                  color: 'primary.dark'
                }
              }}
            >
              {t('see-more')}
            </Typography>
          </Box>
        </FeedHeader>
      )}
      <Grid container spacing={2}>
        {news.slice(0, 3).map((currentNews: any) => (
          <Grid key={currentNews.id} xs={12} md={6} lg={4}>
            <CardHero
              type={1}
              redirect={`/noticias/${currentNews.slug}`}
              cardBrandName={currentNews.brand?.name || null}
              cardVisibility={currentNews.visibility}
              cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
              cardTitle={currentNews.title}
              cardDescription={<div dangerouslySetInnerHTML={{ __html: cutContent(currentNews.content) }} />}
              cardDate={`${moment(currentNews.created_at).fromNow()}`}
              cardActions={
                <ShareIcon
                  visibility={currentNews.visibility}
                  title={currentNews.title}
                  description={currentNews.title}
                  link={`${window.location.origin}/noticias/${currentNews.slug}${window.location.search}`}
                  type="news"
                  multimedia={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
                  buttonText={t('share')}
                />
              }
              favoriteState={Boolean(currentNews.favoriteId)}
              onClickFavorite={handleFavoriteClick(currentNews.id, 'novelty', 'news')}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default NewsFeed
